import { useTranslation } from "react-i18next";

import { Rates } from "@/apps/partner/components/Rates/Rates";
import { Accordion } from "@/components/Interface/Accordion/Accordion";
import { TransformedProduct, TransformedProducts } from "@/utils/tariffUtils";

/**
 * This component is a form that allows the user to select a custom rate and voice option.
 * It is used in the rate selection step of the onboarding process and is the alternative to picking one of the "Mobile Abo" products.
 */
export const CustomRateForm = ({
  options,
  selectedOption,
  currentRate,
  shouldShowEsimTrial,
}: {
  options: TransformedProducts | undefined;
  selectedOption: TransformedProduct | undefined;
  currentRate: string;
  shouldShowEsimTrial: boolean;
  showBestsellerTabs: () => void;
  isBestsellerTabsLinkDisabled?: boolean;
}) => {
  const { t } = useTranslation();
  const { preSelectedProcessedProduct, processedProductsById } = options || {};
  const isFlat2000 = selectedOption?.baseDisplayValue?.includes("2000");

  return (
    <>
      <Accordion
        label={t("Onboarding.sections.rate-selection.yourRate")}
        className="mt-10"
      >
        {processedProductsById && (
          <Rates
            processedProductsById={processedProductsById}
            preSelectedProcessedProduct={preSelectedProcessedProduct}
            currentRate={currentRate}
            shouldShowEsimTrial={shouldShowEsimTrial}
          />
        )}
        {isFlat2000 && (
          <p className="flat-2000-hint">
            {t("translation:Onboarding.sections.rate-selection.flat2000Hint")}
          </p>
        )}
      </Accordion>
      {preSelectedProcessedProduct?.precharged && (
        <p className="font-x-small text-primary-100">
          {t(
            "translation:Onboarding.sections.rate-selection.prechargedRateHint",
          )}
        </p>
      )}
    </>
  );
};
